export default __webpack_public_path__ + "static/media/atas_thumbnail.36700e02.png";